// extracted by mini-css-extract-plugin
module.exports = {"title":"notice_title__2ATNF","text":"notice_text__QW8U_"};